import * as angular from 'angular';
import {IQService} from "angular";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {SubTasksAlertsService} from "./sub-tasks-alerts.service";
import {SubTasksRequestsService} from "./sub-tasks-requests.service";

export class SubTasksService {

  /* @ngInject */
  constructor(private subTasksRequestsService: SubTasksRequestsService, private subTasksAlertsService: SubTasksAlertsService, private $q: IQService, private bringozLoaderService: BringozLoaderService) {
  }

  createTemplate(template) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.subTasksRequestsService.createTemplate(template)
      .then((createdTemplate) => {
        this.subTasksAlertsService.createTemplateSuccess();
        deferred.resolve(createdTemplate)
      })
      .catch((error) => {
        this.subTasksAlertsService.createTemplateError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  updateTemplate(templateId, template) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.subTasksRequestsService.updateTemplate(templateId, template)
      .then((updatedTemplate) => {
        this.subTasksAlertsService.updateTemplateSuccess();
        deferred.resolve(updatedTemplate)
      })
      .catch((error) => {
        this.subTasksAlertsService.updateTemplateError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  deleteTemplate(templateId) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.subTasksRequestsService.deleteTemplate(templateId)
      .then((deletedTemplate) => {
        this.subTasksAlertsService.deleteTemplateSuccess();
        deferred.resolve(deletedTemplate)
      })
      .catch((error) => {
        this.subTasksAlertsService.deleteTemplateError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getTemplatesByIds(ids) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.subTasksRequestsService.getTemplatesByIds(ids)
      .then((templates) => {
        deferred.resolve(templates)
      })
      .catch((error) => {
        // subTasksAlertsService.createTemplateError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getTemplates(types) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.subTasksRequestsService.getTemplates(types)
      .then((templates) => {
        deferred.resolve(templates)
      })
      .catch((error) => {
        this.subTasksAlertsService.getTemplateError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

}
angular
  .module('bringoz.admin.sub-tasks')
  .service('subTasksService', SubTasksService);
